<dx-chart
  *ngIf="trendToTargetIddData && trendToTargetIddData.length"
  [dataSource]="trendToTargetIddData"
  class="chart"
>
  <dxo-argument-axis
    [label]="{ customizeText: customizeTrendToTargetIddText }"
    [tickInterval]="1"
  ></dxo-argument-axis>

  <dxi-series
    type="line"
    argumentField="month"
    valueField="sumIddHoursTarget"
    color="#808080"
    [dashStyle]="dashStyle"
  >
    <dxo-point [visible]="false"></dxo-point>
  </dxi-series>

  <dxi-series
    type="area"
    argumentField="month"
    valueField="sumIddHoursReached"
    color="#66cc66"
  ></dxi-series>

  <dxo-legend [visible]="false"></dxo-legend>
</dx-chart>
